import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { BrandingColors } from "design-system";

// ─── Shared Styles ────────────────────────────────────────────────────────────

export const interactiveBlockStyles = css`
  display: block;
  cursor: pointer;
  z-index: 1;

  &:after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -1;
  }

  &:hover {
    opacity: 1 !important;
  }
`;

// ─── Shared Styled Components ─────────────────────────────────────────────────

export const StAnchor = styled("a")`
  ${interactiveBlockStyles}
`;

// Shared between SideNavMenuItem and SideNavVersionNumber
export const StUserSpan = styled("span")`
  font-size: 10px;
  display: block;
`;

export const StSubNavContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "expanded",
})`
  background: ${BrandingColors.DarkBackground};
  overflow: hidden;
  transition: max-height 500ms
    ${(props) => (props.expanded ? "ease-in" : "ease-out")};
  max-height: ${(props) => (props.expanded ? "500px" : "0")};
`;
